import { render, staticRenderFns } from "./DChangeMonth.vue?vue&type=template&id=35d6f7e7&"
import script from "./DChangeMonth.vue?vue&type=script&lang=js&"
export * from "./DChangeMonth.vue?vue&type=script&lang=js&"
import style0 from "./DChangeMonth.vue?vue&type=style&index=0&id=35d6f7e7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports